import { internal } from "@/public/utils/env.js";
// id0为根节点， 按钮类型['href', 'click', 'display', 'alert']

let funcMap = {
    id: 0,
    name: {
        zh: "",
        en: "",
        fr: "",
        de: "",
        jp: "",
        es: "",
        pt: "",
        it: "",
        tw: "",
        kr: "",
        id: "",
    },
    parentID: null,
    type: "",
    children: [
        // 1 - 50，目前已使用到(6)
        {
            id: 1,
            name: {
                zh: "顶部菜单栏",
                en: "Top Menu",
                fr: "",
                de: "",
                jp: "",
                es: "",
                pt: "",
                it: "",
                tw: "",
                kr: "",
                id: "",
            },
            parentID: null,
            type: "display",
            children: [
                // 51 - 70,目前已使用到(57)
                {
                    id: 51,
                    name: {
                        zh: "文件",
                        en: "File",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 1,
                    type: "click",
                    children: [
                        // 201 - 220,目前已使用到(210)
                        {
                            id: 201,
                            name: {
                                zh: "回到首页",
                                en: "Home",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 51,
                            type: "click",
                            children: [],
                            function: "backToHome",
                        },
                        {
                            id: 202,
                            name: {
                                zh: "保存",
                                en: "Save",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 51,
                            type: "click",
                            children: [],
                            function: "fileSaveFile",
                        },
                        {
                            id: 203,
                            name: {
                                zh: "另存为",
                                en: "Save As",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 51,
                            type: "alert",
                            children: [],
                            function: "fileSaveAs",
                        },
                        {
                            id: 204,
                            name: {
                                zh: "重命名",
                                en: "Rename",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 51,
                            type: "click",
                            children: [],
                            function: "fileReName",
                        },
                        {
                            id: 205,
                            name: {
                                zh: "导入数据",
                                en: "Import Data",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 51,
                            type: "alert",
                            children: [],
                            function: "fileImportData",
                        },
                        {
                            id: 206,
                            name: {
                                zh: "导出/图片/PDF/Word/Excel/PPT/SVG/HTML/Visio",
                                en: "Export/Graphics/PDF/Word/Excel/PowerPoint/SVG/HTML/Visio",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 51,
                            type: "alert",
                            children: [],
                            function: "fileOutputData",
                        },
                        {
                            id: 207,
                            name: {
                                zh: "分享",
                                en: "Share",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 51,
                            type: "alert",
                            children: [],
                            function: "fileShareFile",
                        },
                        {
                            id: 208,
                            name: {
                                zh: "打印",
                                en: "Print",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 51,
                            type: "alert",
                            children: [],
                            function: "filePrintFile",
                        },
                        {
                            id: 209,
                            name: {
                                zh: "页面设置",
                                en: "Page Setup",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 51,
                            type: "click",
                            children: [],
                            function: "filePageSet",
                        },
                        {
                            id: 210,
                            name: {
                                zh: "默认设置",
                                en: "User Preference",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 51,
                            type: "alert",
                            children: [],
                            function: "fileOptions",
                        },
                        {
                            id: 211,
                            name: {
                                zh: "文档加密",
                                en: "Encrypt",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 51,
                            type: "alert",
                            children: [],
                            function: "fileEncrypt",
                        },
                        {
                            id: 212,
                            name: {
                                zh: "下载",
                                en: "Download",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 51,
                            type: "alert",
                            children: [],
                            function: "fileDownload",
                        },
                        {
                            id: 213,
                            name: {
                                zh: "星标/设置星标/取消星标",
                                en: "Star/Add star/Cancel star",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 51,
                            type: "alert",
                            children: [],
                            function: "fileStar",
                        },
                    ],
                    function: "topMenuFile",
                },
                {
                    id: 52,
                    name: {
                        zh: "编辑",
                        en: "Edit",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 1,
                    type: "click",
                    children: [
                        // 221 - 240,目前已使用到(230)
                        {
                            id: 221,
                            name: {
                                zh: "撤销",
                                en: "Undo",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 52,
                            type: "click",
                            children: [],
                            function: "editUndo",
                        },
                        {
                            id: 222,
                            name: {
                                zh: "重做",
                                en: "Redo",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 52,
                            type: "click",
                            children: [],
                            function: "editRedo",
                        },
                        {
                            id: 223,
                            name: {
                                zh: "剪切",
                                en: "Cut",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 52,
                            type: "click",
                            children: [],
                            function: "editCut",
                        },
                        {
                            id: 224,
                            name: {
                                zh: "复制",
                                en: "Copy",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 52,
                            type: "click",
                            children: [],
                            function: "editCopy",
                        },
                        {
                            id: 225,
                            name: {
                                zh: "粘贴",
                                en: "Paste",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 52,
                            type: "click",
                            children: [],
                            function: "editPaste",
                        },
                        {
                            id: 226,
                            name: {
                                zh: "格式刷",
                                en: "Style Brush",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 52,
                            type: "click",
                            children: [],
                            function: "editStyleBrush",
                        },
                        {
                            id: 228,
                            name: {
                                zh: "快速样式",
                                en: "Quick Style",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 52,
                            type: "click",
                            children: [],
                            function: "editSetDefaultStyle",
                        },
                        {
                            id: 229,
                            name: {
                                zh: "查找替换",
                                en: "Find & Replace",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 52,
                            type: "click",
                            children: [],
                            function: "editReplace",
                        },
                        {
                            id: 230,
                            name: {
                                zh: "创建智能形状",
                                en: "Create Smart Shape",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 52,
                            type: "click",
                            children: [],
                            function: "editCreateSmartShape",
                        },
                    ],
                    function: "topMenuEdit",
                },
                {
                    id: 53,
                    name: {
                        zh: "插入",
                        en: "Insert",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 1,
                    type: "click",
                    children: [
                        // 241 - 260,目前已使用到(250)
                        {
                            id: 241,
                            name: {
                                zh: "注释",
                                en: "Note",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 53,
                            type: "alert",
                            children: [],
                            function: "insertNote",
                        },
                        {
                            id: 242,
                            name: {
                                zh: "评论",
                                en: "Comment",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 53,
                            type: "alert",
                            children: [],
                            function: "insertComment",
                        },
                        {
                            id: 243,
                            name: {
                                zh: "超链接",
                                en: "Hyperlink",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 53,
                            type: "alert",
                            children: [],
                            function: "insertHylink",
                        },
                        {
                            id: 244,
                            name: {
                                zh: "图片",
                                en: "Image",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 53,
                            type: "alert",
                            children: [],
                            function: "insertImage",
                        },
                        {
                            id: 245,
                            name: {
                                zh: "表格",
                                en: "Table",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 53,
                            type: "alert",
                            children: [],
                            function: "insertTable",
                        },
                        {
                            id: 246,
                            name: {
                                zh: "图表",
                                en: "Chart",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 53,
                            type: "alert",
                            children: [],
                            function: "insertChart",
                        },
                        {
                            id: 247,
                            name: {
                                zh: "地图",
                                en: "Map",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 53,
                            type: "alert",
                            children: [],
                            function: "insertMap",
                        },
                        {
                            id: 248,
                            name: {
                                zh: "数学公式",
                                en: "Math Equation",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 53,
                            type: "alert",
                            children: [],
                            function: "insertMath",
                        },
                        {
                            id: 249,
                            name: {
                                zh: "二维码",
                                en: "QR Code",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 53,
                            type: "alert",
                            children: [],
                            function: "insertQRCode",
                        },
                        {
                            id: 250,
                            name: {
                                zh: "水印",
                                en: "Watermark",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 53,
                            type: "alert",
                            children: [],
                            function: "insertWaterMark",
                        },
                        {
                            id: 251,
                            name: {
                                zh: "附件",
                                en: "Attachment",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 53,
                            type: "alert",
                            children: [],
                            function: "insertAttach",
                        },
                        {
                            id: 252,
                            name: {
                                zh: "时间线",
                                en: "Timeline",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 53,
                            type: "alert",
                            children: [],
                            function: "insertTimeline",
                        },
                        {
                            id: 253,
                            name: {
                                zh: "容器",
                                en: "Container",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 53,
                            type: "alert",
                            children: [],
                            function: "insertContainer",
                        },
                    ],
                    function: "topMenuInsert",
                },
                {
                    id: 54,
                    name: {
                        zh: "布局",
                        en: "Layout",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 1,
                    type: "click",
                    children: [
                        // 261 - 280,目前已使用到(271)
                        {
                            id: 261,
                            name: {
                                zh: "移至顶层",
                                en: "Bring to Front",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 54,
                            type: "click",
                            children: [],
                            function: "alignMoveTop",
                        },
                        {
                            id: 262,
                            name: {
                                zh: "移至底层",
                                en: "Send to Back",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 54,
                            type: "click",
                            children: [],
                            function: "alignMoveBottom",
                        },
                        {
                            id: 263,
                            name: {
                                zh: "前移一层",
                                en: "Bring Forward",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 54,
                            type: "click",
                            children: [],
                            function: "alignMoveUp",
                        },
                        {
                            id: 264,
                            name: {
                                zh: "后移一层",
                                en: "Send Backward",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 54,
                            type: "click",
                            children: [],
                            function: "alignMoveDown",
                        },
                        {
                            id: 265,
                            name: {
                                zh: "对齐",
                                en: "Align",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 54,
                            type: "click",
                            children: [],
                            function: "alignAlign",
                        },
                        {
                            id: 266,
                            name: {
                                zh: "分布",
                                en: "Distribute",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 54,
                            type: "click",
                            children: [],
                            function: "alignDistribute",
                        },
                        {
                            id: 267,
                            name: {
                                zh: "等大小",
                                en: "Same Size",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 54,
                            type: "click",
                            children: [],
                            function: "alignSameSize",
                        },
                        {
                            id: 268,
                            name: {
                                zh: "锁定",
                                en: "Lock",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 54,
                            type: "click",
                            children: [],
                            function: "alignLock",
                        },
                        {
                            id: 269,
                            name: {
                                zh: "解锁",
                                en: "Unlock",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 54,
                            type: "click",
                            children: [],
                            function: "alignUnlockAll",
                        },
                        {
                            id: 270,
                            name: {
                                zh: "组合",
                                en: "Group",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 54,
                            type: "click",
                            children: [],
                            function: "alignGroup",
                        },
                        {
                            id: 271,
                            name: {
                                zh: "取消组合",
                                en: "Ungroup",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 54,
                            type: "click",
                            children: [],
                            function: "alignUngroup",
                        },
                    ],
                    function: "topMenuArrange",
                },
                {
                    id: 55,
                    name: {
                        zh: "视图",
                        en: "View",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 1,
                    type: "click",
                    children: [
                        // 281 - 300,目前已使用到(293)
                        {
                            id: 281,
                            name: {
                                zh: "放大",
                                en: "Zoom in",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 55,
                            type: "click",
                            children: [],
                            function: "viewZoomIn",
                        },
                        {
                            id: 282,
                            name: {
                                zh: "缩小",
                                en: "Zoom out",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 55,
                            type: "click",
                            children: [],
                            function: "viewZoomOut",
                        },
                        {
                            id: 283,
                            name: {
                                zh: "适应内容",
                                en: "Fit to Content",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 55,
                            type: "click",
                            children: [],
                            function: "viewFitToContent",
                        },
                        {
                            id: 284,
                            name: {
                                zh: "适应宽度",
                                en: "Fit to Page Width",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 55,
                            type: "click",
                            children: [],
                            function: "viewFitToPageWidth",
                        },
                        {
                            id: 285,
                            name: {
                                zh: "适应页面",
                                en: "Fit to Whole Page",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 55,
                            type: "click",
                            children: [],
                            function: "viewFitToPage",
                        },
                        {
                            id: 286,
                            name: {
                                zh: "页面适应到形状",
                                en: "Fit to Drawing",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 55,
                            type: "click",
                            children: [],
                            function: "viewFitToDrawing",
                        },
                        {
                            id: 287,
                            name: {
                                zh: "网格",
                                en: "Grid",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 55,
                            type: "click",
                            children: [],
                            function: "viewGrid",
                        },
                        {
                            id: 288,
                            name: {
                                zh: "参考线",
                                en: "Guides",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 55,
                            type: "click",
                            children: [],
                            function: "viewGuides",
                        },
                        {
                            id: 289,
                            name: {
                                zh: "页面边距",
                                en: "Margins",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 55,
                            type: "click",
                            children: [],
                            function: "viewMargins",
                        },
                        {
                            id: 290,
                            name: {
                                zh: "标尺",
                                en: "Ruler",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 55,
                            type: "click",
                            children: [],
                            function: "viewRuler",
                        },
                        {
                            id: 291,
                            name: {
                                zh: "浮动按钮",
                                en: "Float Button",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 55,
                            type: "click",
                            children: [],
                            function: "viewFloatButton",
                        },
                        {
                            id: 292,
                            name: {
                                zh: "显示符号库",
                                en: "Show Library",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 55,
                            type: "click",
                            children: [],
                            function: "viewShowLibrary",
                        },
                        {
                            id: 293,
                            name: {
                                zh: "显示数据表",
                                en: "Data Sheet",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 55,
                            type: "click",
                            children: [],
                            function: "viewShowDataSheet",
                        },
                        {
                            id: 294,
                            name: {
                                zh: "自定义工具栏",
                                en: "Customize toolbars",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 55,
                            type: "click",
                            children: [],
                            function: "viewToolbar",
                        },
                        {
                            id: 295,
                            name: {
                                zh: "悬浮坐标值",
                                en: "Symbol coordinate value",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 55,
                            type: "click",
                            children: [],
                            function: "viewMoveCoord",
                        },
                        {
                            id: 296,
                            name: {
                                zh: "分页符",
                                en: "Page Breaks",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 55,
                            type: "click",
                            children: [],
                            function: "viewPageBreak",
                        },
                    ],
                    function: "topMenuView",
                },
                {
                    id: 56,
                    name: {
                        zh: "符号",
                        en: "Symbol",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 1,
                    type: "click",
                    children: [
                        // 301 - 320,目前已使用到(308)
                        // {
                        //     id: 301,
                        //     name: {
                        //         zh: '保存符号',
                        //         en: 'Save Symbol',
                        //         fr: '',
                        //         de: '',
                        //         jp: '',
                        //         es: '',
                        //         pt: '',
                        //         it: '',
                        //         tw: '',
                        //         kr: '',
                        //         id: ''
                        //     },
                        //     parentID: 56,
                        //     type: 'click',
                        //     children: [],
                        //     function: 'shapeSaveSymbol'
                        // },
                        window.EDCONFIG.MY_LIBRARY_ENABLE
                            ? {
                                  id: 302,
                                  name: {
                                      zh: "新建符号库",
                                      en: "New Library",
                                      fr: "",
                                      de: "",
                                      jp: "",
                                      es: "",
                                      pt: "",
                                      it: "",
                                      tw: "",
                                      kr: "",
                                      id: "",
                                  },
                                  parentID: 56,
                                  type: "alert",
                                  children: [],
                                  function: "shapeNewLibrary",
                              }
                            : null,
                        window.EDCONFIG.MY_LIBRARY_ENABLE
                            ? {
                                  id: 303,
                                  name: {
                                      zh: "导入符号库",
                                      en: "Open Library",
                                      fr: "",
                                      de: "",
                                      jp: "",
                                      es: "",
                                      pt: "",
                                      it: "",
                                      tw: "",
                                      kr: "",
                                      id: "",
                                  },
                                  parentID: 56,
                                  type: "alert",
                                  children: [],
                                  function: "shapeOpenLibrary",
                              }
                            : null,
                        // {
                        //     id: 304,
                        //     name: {
                        //         zh: '导入图片生成库',
                        //         en: 'New Library From Pictures',
                        //         fr: '',
                        //         de: '',
                        //         jp: '',
                        //         es: '',
                        //         pt: '',
                        //         it: '',
                        //         tw: '',
                        //         kr: '',
                        //         id: ''
                        //     },
                        //     parentID: 56,
                        //     type: 'display',
                        //     children: [],
                        //     function: 'shapeNewLibraryFromPictures'
                        // },
                        {
                            id: 305,
                            name: {
                                zh: "添加带有控制点的文本框",
                                en: "Add Text With Control Point",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 56,
                            type: "click",
                            children: [],
                            function: "shapeAddTextWidthControlPoint",
                        },
                        {
                            id: 306,
                            name: {
                                zh: "在形状上方添加文本框",
                                en: "Add Text Above Shape",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 56,
                            type: "click",
                            children: [],
                            function: "shapeAddTextAboveShape",
                        },
                        {
                            id: 307,
                            name: {
                                zh: "自动添加连接点",
                                en: "Add Connection Points Automatically",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 56,
                            type: "click",
                            children: [],
                            function: "shapeAddConnectionPointsAutomatically",
                        },
                        {
                            id: 308,
                            name: {
                                zh: "删除连接点",
                                en: "Remove Connection Points",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 56,
                            type: "click",
                            children: [],
                            function: "shapeRmoveConnectionPoints",
                        },
                    ].filter(Boolean),
                    function: "topMenuSymbol",
                },
                {
                    id: 57,
                    name: {
                        zh: "选择",
                        en: "Select",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 1,
                    type: "click",
                    children: [
                        // 321 - 340,目前已使用到(321)
                        {
                            id: 321,
                            name: {
                                zh: "所有/选择所有/选中所有",
                                en: "All/Select All",
                                fr: "tout",
                                de: "Alles",
                                jp: "すべて",
                                es: "todas",
                                pt: "tudo",
                                it: "tutti",
                                tw: "所有/選擇所有/選中所有",
                                kr: "",
                                id: "",
                            },
                            parentID: 57,
                            type: "click",
                            children: [],
                            function: "selectAll",
                        },
                        {
                            id: 322,
                            name: {
                                zh: "所有形状/选择所有形状/选中所有形状",
                                en: "All shapes/Select All Shapes",
                                fr: "Toutes formes",
                                de: "Alle Formen",
                                jp: "すべての形",
                                es: "Todas las formas",
                                pt: "Todas as formas",
                                it: "Tutte le forme",
                                tw: "所有形狀/選擇所有形狀/選中所有形狀",
                                kr: "",
                                id: "",
                            },
                            parentID: 57,
                            type: "alert",
                            children: [],
                            function: "selectAllShapes",
                        },
                        {
                            id: 323,
                            name: {
                                zh: "所有连接线/选择所有连接线/选中所有连接线",
                                en: "All connection lines/Select All connection lines",
                                fr: "Toutes les lignes de connexion",
                                de: "Alle Verbindungsleitungen",
                                jp: "すべての接続線",
                                es: "Todas las líneas de conexión",
                                pt: "Todas as linhas de conexão",
                                it: "Tutte le linee di collegamento",
                                tw: "所有連接線/選擇所有連接線/選中所有連接線",
                                kr: "",
                                id: "",
                            },
                            parentID: 57,
                            type: "click",
                            children: [],
                            function: "selectAllLines",
                        },
                        {
                            id: 343,
                            name: {
                                zh: "所有图片/选择所有图片/选中所有图片",
                                en: "All images/Select All images",
                                fr: "Toutes les photos",
                                de: "Alle Bilder",
                                jp: "すべての写真",
                                es: "Todas las imágenes",
                                pt: "Todas as fotos",
                                it: "Tutte le immagini",
                                tw: "所有圖片/選擇所有圖片/選中所有圖片",
                                kr: "",
                                id: "",
                            },
                            parentID: 57,
                            type: "click",
                            children: [],
                            function: "selectAllImages",
                        },
                        {
                            id: 344,
                            name: {
                                zh: "所有参考线/选择所有参考线/选中所有参考线",
                                en: "All reference lines/Select All reference lines",
                                fr: "Toutes les lignes de référence",
                                de: "Alle Referenzlinien",
                                jp: "すべての参照線",
                                es: "Todas las líneas de referencia",
                                pt: "Todas as linhas de referência",
                                it: "Tutte le linee di riferimento",
                                tw: "所有參考線/選擇所有參考線/選中所有參考線",
                                kr: "",
                                id: "",
                            },
                            parentID: 57,
                            type: "click",
                            children: [],
                            function: "selectAllGuideLines",
                        },
                        {
                            id: 345,
                            name: {
                                zh: "按图层选中",
                                en: "Select by Layer",
                                fr: "Sélectionnez par couche",
                                de: "Nach Ebene auswählen",
                                jp: "レイヤーで選択",
                                es: "Seleccionar por capa",
                                pt: "Selecione por camada",
                                it: "Seleziona per livello",
                                tw: "按圖層選中",
                                kr: "",
                                id: "",
                            },
                            parentID: 57,
                            type: "click",
                            children: [],
                            function: "selectByLayer",
                        },
                        {
                            id: 346,
                            name: {
                                zh: "同类型形状/选择同类型形状/选中同类型形状",
                                en: "Same type of shape/Select Same type of shape",
                                fr: "Même type de forme",
                                de: "Gleiche Form",
                                jp: "同型形状",
                                es: "Mismo tipo de forma",
                                pt: "Forma do mesmo tipo",
                                it: "Stesso tipo di forma",
                                tw: "同類型形狀/選擇同類型形狀/選中同類型形狀",
                                kr: "",
                                id: "",
                            },
                            parentID: 57,
                            type: "click",
                            children: [],
                            function: "selectByShape",
                        },
                        {
                            id: 347,
                            name: {
                                zh: "同类型连接线/选择同类型连接线/选中同类型连接线",
                                en: "Same type connecting line/Select Same type connecting line",
                                fr: "Même type de ligne de connexion",
                                de: "Verbindungsleitung vom gleichen Typ",
                                jp: "同じタイプの接続線",
                                es: "Mismo tipo de línea de conexión",
                                pt: "Linha de conexão do mesmo tipo",
                                it: "Stesso tipo di linea di collegamento",
                                tw: "同類型連接線/選擇同類型連接線/選中同類型連接線",
                                kr: "",
                                id: "",
                            },
                            parentID: 57,
                            type: "click",
                            children: [],
                            function: "selectByLines",
                        },
                        {
                            id: 348,
                            name: {
                                zh: "从选择中排除",
                                en: "Exclude from selection",
                                fr: "Exclusion de la sélection",
                                de: "Aus der Auswahl ausschließen",
                                jp: "選択から除外する",
                                es: "Excluir de la selección",
                                pt: "Excluir Da seleção",
                                it: "Esclusi dalla selezione",
                                tw: "從選擇中排除",
                                kr: "",
                                id: "",
                            },
                            parentID: 57,
                            type: "click",
                            children: [],
                            function: "selectExclude",
                        },
                    ],
                    function: "topMenuSelect",
                },
                {
                    id: 60,
                    name: {
                        zh: "保存",
                        en: "Save",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 1,
                    type: "click",
                    children: [],
                    function: "menuSaveFile",
                },
                {
                    id: 61,
                    name: {
                        zh: "星标/设置星标/取消星标",
                        en: "Star/Add star/Cancel star",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 1,
                    type: "click",
                    children: [],
                    function: "menuStarFile",
                },
                {
                    id: 64,
                    name: {
                        zh: "导出",
                        en: "Export",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 1,
                    type: "alert",
                    children: [],
                    function: "menuOutputFile",
                },
            ],
            function: "",
        },
        {
            id: 2,
            name: {
                zh: "顶部工具栏",
                en: "Top Toolbar",
                fr: "",
                de: "",
                jp: "",
                es: "",
                pt: "",
                it: "",
                tw: "",
                kr: "",
                id: "",
            },
            parentID: null,
            type: "display",
            children: [
                // 71 - 100,目前已使用到(92)
                {
                    id: 71,
                    name: {
                        zh: "撤销",
                        en: "Undo",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [],
                    function: "tabsUndo",
                },
                {
                    id: 72,
                    name: {
                        zh: "重做",
                        en: "Redo",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [],
                    function: "tabsRedo",
                },
                {
                    id: 73,
                    name: {
                        zh: "加粗",
                        en: "Bold",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [],
                    function: "tabsBold",
                },
                {
                    id: 74,
                    name: {
                        zh: "斜体",
                        en: "Italic",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [],
                    function: "tabsItaly",
                },
                {
                    id: 75,
                    name: {
                        zh: "下划线",
                        en: "Underline",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [],
                    function: "tabsUnderline",
                },
                {
                    id: 76,
                    name: {
                        zh: "下划线",
                        en: "Font Color",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [],
                    function: "tabsFontColor",
                },
                {
                    id: 77,
                    name: {
                        zh: "文本在路径上",
                        en: "Text on path",
                        fr: "Texte sur un chemin",
                        de: "Text auf Pfad",
                        jp: "テキストの並べ方",
                        es: "Texto en Trazados",
                        pt: "Texto num caminho",
                        it: "Testo lungo tracciato",
                        tw: "線上文本",
                        kr: "텍스트",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [],
                    function: "tabsFontAround",
                },
                {
                    id: 78,
                    name: {
                        zh: "对齐方式",
                        en: "Align",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [],
                    function: "tabsFontAlign",
                },
                {
                    id: 79,
                    name: {
                        zh: "更多文本设置",
                        en: "More Options",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [
                        // 341 - 360 ,目前已使用到(349)
                        {
                            id: 341,
                            name: {
                                zh: "删除线",
                                en: "Strikethrough",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 79,
                            type: "click",
                            children: [],
                            function: "tabsDeleteLine",
                        },
                        {
                            id: 342,
                            name: {
                                zh: "背景色",
                                en: "Text Heightlignt Color",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 79,
                            type: "click",
                            children: [],
                            function: "tabsFontBgColor",
                        },
                        {
                            id: 343,
                            name: {
                                zh: "列表样式",
                                en: "Bullets",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 79,
                            type: "click",
                            children: [],
                            function: "tabsFontListStyle",
                        },
                        {
                            id: 344,
                            name: {
                                zh: "行间距",
                                en: "Line Height",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 79,
                            type: "click",
                            children: [],
                            function: "tabsLineHeight",
                        },
                        {
                            id: 345,
                            name: {
                                zh: "首行缩进",
                                en: "First Line",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 79,
                            type: "click",
                            children: [],
                            function: "tabsFirstIndent",
                        },
                        {
                            id: 346,
                            name: {
                                zh: "左侧缩进",
                                en: "Left",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 79,
                            type: "click",
                            children: [],
                            function: "tabsLeftIndent",
                        },
                        {
                            id: 347,
                            name: {
                                zh: "右侧缩进",
                                en: "Right",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 79,
                            type: "click",
                            children: [],
                            function: "tabsRightIndent",
                        },
                        {
                            id: 348,
                            name: {
                                zh: "段前间距",
                                en: "Before",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 79,
                            type: "click",
                            children: [],
                            function: "tabsBefore",
                        },
                        {
                            id: 349,
                            name: {
                                zh: "段后间距",
                                en: "After",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 79,
                            type: "click",
                            children: [],
                            function: "tabsAfter",
                        },
                    ],
                    function: "tabsFontOption",
                },
                {
                    id: 80,
                    name: {
                        zh: "添加文本",
                        en: "Add Text",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [],
                    function: "tabsAddText",
                },
                {
                    id: 81,
                    name: {
                        zh: "连接线",
                        en: "Connector",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [
                        // 361 - 370 ,目前已使用到(363)
                        // {
                        //     id: 361,
                        //     name: {
                        //         zh: '直角连接线',
                        //         en: '',
                        //         fr: '',
                        //         de: '',
                        //         jp: '',
                        //         es: '',
                        //         pt: '',
                        //         it: '',
                        //         tw: '',
                        //         kr: '',
                        //         id: ''
                        //     },
                        //     parentID: 81,
                        //     type: 'click',
                        //     children: [],
                        //     function: 'tabsConnectLine1'
                        // },
                        // {
                        //     id: 362,
                        //     name: {
                        //         zh: '曲线连接线',
                        //         en: '',
                        //         fr: '',
                        //         de: '',
                        //         jp: '',
                        //         es: '',
                        //         pt: '',
                        //         it: '',
                        //         tw: '',
                        //         kr: '',
                        //         id: ''
                        //     },
                        //     parentID: 81,
                        //     type: 'click',
                        //     children: [],
                        //     function: 'tabsConnectLine2'
                        // },
                        // {
                        //     id: 363,
                        //     name: {
                        //         zh: '直线连接线',
                        //         en: '',
                        //         fr: '',
                        //         de: '',
                        //         jp: '',
                        //         es: '',
                        //         pt: '',
                        //         it: '',
                        //         tw: '',
                        //         kr: '',
                        //         id: ''
                        //     },
                        //     parentID: 81,
                        //     type: 'click',
                        //     children: [],
                        //     function: 'tabsConnectLine3'
                        // },
                    ],
                    function: "tabsConnectLine",
                },
                {
                    id: 82,
                    name: {
                        zh: "位置、宽高、角度",
                        en: "Position、Width、height、Angle",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [
                        // 371 - 380 ,目前已使用到(375)
                        {
                            id: 371,
                            name: {
                                zh: "水平镜像",
                                en: "mirror Horizontally",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 82,
                            type: "click",
                            children: [],
                            function: "tabsHMirror",
                        },
                        {
                            id: 372,
                            name: {
                                zh: "垂直镜像",
                                en: "mirror vertically",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 82,
                            type: "click",
                            children: [],
                            function: "tabsVMirror",
                        },
                        {
                            id: 373,
                            name: {
                                zh: "旋转",
                                en: "Rotate",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 82,
                            type: "click",
                            children: [],
                            function: "tabsRotate",
                        },
                        {
                            id: 374,
                            name: {
                                zh: "顺时针旋转90°",
                                en: "Rotate 90°",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 83,
                            type: "click",
                            children: [],
                            function: "clockWiseRotate",
                        },
                        {
                            id: 375,
                            name: {
                                zh: "逆时针旋转90°",
                                en: "Rotate -90°",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 84,
                            type: "click",
                            children: [],
                            funtion: "anticClockWiseRotate",
                        },
                    ],
                    function: "tabsLayout",
                },
                {
                    id: 83,
                    name: {
                        zh: "层级",
                        en: "Layer",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [
                        // 381 - 390 ,目前已使用到(384)
                        {
                            id: 381,
                            name: {
                                zh: "移至顶层",
                                en: "Bring to Front",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 83,
                            type: "click",
                            children: [],
                            function: "tabsMoveTop",
                        },
                        {
                            id: 382,
                            name: {
                                zh: "移至底部",
                                en: "Send to Back",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 83,
                            type: "click",
                            children: [],
                            function: "tabsMoveBottom",
                        },
                        {
                            id: 383,
                            name: {
                                zh: "上移一层",
                                en: "Bring Forward",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 83,
                            type: "click",
                            children: [],
                            function: "tabsMoveUp",
                        },
                        {
                            id: 384,
                            name: {
                                zh: "下移一层",
                                en: "Send Backward",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 83,
                            type: "click",
                            children: [],
                            function: "tabsMoveDown",
                        },
                    ],
                    function: "tabsLayer",
                },
                {
                    id: 84,
                    name: {
                        zh: "布局、对齐、等宽高",
                        en: "Layout、Alignment、Aspect Ratio",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [],
                    function: "tabsAlign",
                },
                {
                    id: 85,
                    name: {
                        zh: "组合",
                        en: "Group",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [],
                    function: "tabsGroup",
                },
                {
                    id: 86,
                    name: {
                        zh: "填充颜色",
                        en: "Fill Color",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [],
                    function: "tabsFillColor",
                },
                {
                    id: 87,
                    name: {
                        zh: "线条颜色",
                        en: "Line Color",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [],
                    function: "tabsLineCoor",
                },
                {
                    id: 88,
                    name: {
                        zh: "线条样式",
                        en: "Line Style",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [
                        // 391 - 400 ,目前已使用到(397)
                        {
                            id: 391,
                            name: {
                                zh: "线条宽度",
                                en: "Line Width",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 88,
                            type: "click",
                            children: [],
                            function: "tabsLineWidth",
                        },
                        {
                            id: 392,
                            name: {
                                zh: "箭头样式",
                                en: "Arrow Style",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 88,
                            type: "click",
                            children: [],
                            function: "tabsArrowStyle",
                        },
                        {
                            id: 393,
                            name: {
                                zh: "圆角大小",
                                en: "Rounding Sizing",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 88,
                            type: "click",
                            children: [],
                            function: "tabsBorderRadio",
                        },
                        {
                            id: 394,
                            name: {
                                zh: "箭头大小",
                                en: "Arrow Size",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 88,
                            type: "click",
                            children: [],
                            function: "tabsArrowSize",
                        },
                        {
                            id: 395,
                            name: {
                                zh: "连接线样式",
                                en: "Line Type",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 88,
                            type: "click",
                            children: [],
                            function: "tabsConnectLineStyle",
                        },
                        {
                            id: 396,
                            name: {
                                zh: "跳点方案",
                                en: "Jump Direction",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 88,
                            type: "click",
                            children: [],
                            function: "tabsConnectorPoint",
                        },
                        {
                            id: 397,
                            name: {
                                zh: "跳点样式",
                                en: "Jump Style",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 88,
                            type: "click",
                            children: [],
                            function: "tabsConnectorPointStyle",
                        },
                    ],
                    function: "tabsLineStyle",
                },
                {
                    id: 89,
                    name: {
                        zh: "锁定",
                        en: "Protect",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [],
                    function: "tabsLock",
                },
                {
                    id: 90,
                    name: {
                        zh: "特殊设置",
                        en: "Exceptional Settings",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [],
                    function: "tabsSpeciaOption",
                },
                {
                    id: 91,
                    name: {
                        zh: "快速样式",
                        en: "Quick Style",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [],
                    function: "tabsSetDefaultStyle",
                },
                {
                    id: 92,
                    name: {
                        zh: "查找",
                        en: "Find",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [],
                    function: "tabsReplace",
                },
                {
                    id: 93,
                    name: {
                        zh: "一键美化",
                        en: "Auto Formatting",
                        fr: "Formatage automatique",
                        de: "Automatisch formatieren",
                        jp: "自動フォーマット",
                        es: "Formateo automático",
                        pt: "Formatação Automática",
                        it: "Formattazione automatica",
                        tw: "一鍵美化",
                        kr: "autoFormatting",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [],
                    function: "tabsBeautify",
                },
                {
                    id: 94,
                    name: {
                        zh: "批量替换颜色",
                        en: "Batch Replace Color",
                        fr: "Remplacement de la couleur par lot",
                        de: "Farbe stapelweise ersetzen",
                        jp: "色の一括置換",
                        es: "Lote reemplazar color",
                        pt: "Cor de substituição em lote",
                        it: "Batch Sostituisci colore",
                        tw: "批量替換顏色",
                        kr: "배치 색깔 바꾸기",
                        id: "",
                    },
                    parentID: 2,
                    type: "click",
                    children: [],
                    function: "tabsReplaceClr",
                },
            ],
            function: "",
        },
        {
            id: 3,
            name: {
                zh: "右侧工具栏",
                en: "Right Toolbar",
                fr: "",
                de: "",
                jp: "",
                es: "",
                pt: "",
                it: "",
                tw: "",
                kr: "",
                id: "",
            },
            parentID: null,
            type: "display",
            children: [
                // 101 - 130,目前已使用到(115)
                {
                    id: 101,
                    name: {
                        zh: "样式",
                        en: "Style",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 3,
                    type: "click",
                    children: [
                        // 401 - 410,目前已使用到(403)
                        {
                            id: 401,
                            name: {
                                zh: "填充",
                                en: "Fill",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 101,
                            type: "click",
                            children: [],
                            function: "rightStyleFill",
                        },
                        {
                            id: 402,
                            name: {
                                zh: "线条",
                                en: "Line",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 101,
                            type: "click",
                            children: [],
                            function: "rightStyleLine",
                        },
                        {
                            id: 403,
                            name: {
                                zh: "阴影",
                                en: "Shadow",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 101,
                            type: "click",
                            children: [],
                            function: "rightStyleShadow",
                        },
                    ],
                    function: "showRightStyle",
                },
                {
                    id: 102,
                    name: {
                        zh: "页面设置",
                        en: "Page Settings",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 3,
                    type: "click",
                    children: [
                        // 411 - 417，目前已使用到(417)
                        {
                            id: 411,
                            name: {
                                zh: "背景色",
                                en: "Background",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 102,
                            type: "click",
                            children: [],
                            function: "rightPageBgColor",
                        },
                        {
                            id: 412,
                            name: {
                                zh: "删除背景",
                                en: "Remove Background",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 102,
                            type: "click",
                            children: [],
                            function: "rightPageDeleteBg",
                        },
                        {
                            id: 413,
                            name: {
                                zh: "水印",
                                en: "Watermark",
                                fr: "",
                                de: "",
                                jp: "",
                                es: "",
                                pt: "",
                                it: "",
                                tw: "",
                                kr: "",
                                id: "",
                            },
                            parentID: 102,
                            type: "click",
                            children: [],
                            function: "rightPageWaterMark",
                        },
                    ],
                    function: "showRightPage",
                },
                {
                    id: 103,
                    name: {
                        zh: "主题",
                        en: "Theme",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 3,
                    type: "click",
                    children: [],
                    function: "showRightTheme",
                },
                {
                    id: 105,
                    name: {
                        zh: "文档演示",
                        en: "Slide",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 3,
                    type: "click",
                    children: [],
                    function: "showRightSlide",
                },
                {
                    id: 106,
                    name: {
                        zh: "形状数据",
                        en: "Data Property",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 3,
                    type: "click",
                    children: [],
                    function: "showRightProperty",
                },
                {
                    id: 112,
                    name: {
                        zh: "历史版本",
                        en: "History",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 3,
                    type: "click",
                    children: [],
                    function: "showRightHistory",
                },
            ],
            function: "",
        },
        {
            id: 4,
            name: {
                zh: "底部工具栏",
                en: "Bottom Toolbar",
                fr: "",
                de: "",
                jp: "",
                es: "",
                pt: "",
                it: "",
                tw: "",
                kr: "",
                id: "",
            },
            parentID: null,
            type: "display",
            children: [
                // 131 - 150,目前已使用到(136)
                {
                    id: 131,
                    name: {
                        zh: "预览页面",
                        en: "Preview Page",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 4,
                    type: "click",
                    children: [],
                    function: "previewPage",
                },
                {
                    id: 132,
                    name: {
                        zh: "新增页面",
                        en: "Add Page",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 4,
                    type: "click",
                    children: [],
                    function: "addPage",
                },
                {
                    id: 133,
                    name: {
                        zh: "缩小页面",
                        en: "Zoom out",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 4,
                    type: "click",
                    children: [],
                    function: "smallPage",
                },
                {
                    id: 134,
                    name: {
                        zh: "放大页面",
                        en: "Zoom in",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 4,
                    type: "click",
                    children: [],
                    function: "bigPage",
                },
                {
                    id: 135,
                    name: {
                        zh: "适应页面",
                        en: "Fit to Whole Page",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 4,
                    type: "click",
                    children: [],
                    function: "fitPage",
                },
                {
                    id: 136,
                    name: {
                        zh: "页面演示",
                        en: "Present Page",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 1,
                    type: "click",
                    children: [],
                    function: "menuPageSlice",
                },
                {
                    id: 137,
                    name: {
                        zh: "图层",
                        en: "Layer",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 3,
                    type: "click",
                    children: [],
                    function: "bottomLayer",
                },
                {
                    id: 138,
                    name: {
                        zh: "专注/专注模式",
                        en: "Focus/Focus Mode",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 3,
                    type: "click",
                    children: [],
                    function: "bottomFocus",
                },
            ],
            function: "",
        },
        {
            id: 5,
            name: {
                zh: "符号库",
                en: "Library",
                fr: "",
                de: "",
                jp: "",
                es: "",
                pt: "",
                it: "",
                tw: "",
                kr: "",
                id: "",
            },
            parentID: null,
            type: "display",
            children: [
                // 151 - 170,目前已使用到(153)
                {
                    id: 151,
                    name: {
                        zh: "打开符号库",
                        en: "Add Library",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 4,
                    type: "alert",
                    children: [],
                    function: "showLibrary",
                },
                {
                    id: 152,
                    name: {
                        zh: "查找符号",
                        en: "Search Library",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 4,
                    type: "click",
                    children: [],
                    function: "showSearchLibrary",
                },
                window.EDCONFIG.MY_LIBRARY_ENABLE
                    ? {
                          id: 153,
                          name: {
                              zh: "我的收藏",
                              en: "My collect",
                              fr: "",
                              de: "",
                              jp: "",
                              es: "",
                              pt: "",
                              it: "",
                              tw: "",
                              kr: "",
                              id: "",
                          },
                          parentID: 4,
                          type: "click",
                          children: [],
                          function: "showCollectLibrary",
                      }
                    : null,
            ].filter(Boolean),
            function: "",
        },
        {
            id: 7,
            name: {
                zh: "右上角",
                en: "Upper Right Corner",
                fr: "",
                de: "",
                jp: "",
                es: "",
                pt: "",
                it: "",
                tw: "",
                kr: "",
                id: "",
            },
            parentID: null,
            type: "display",
            children: [
                // 171 - 180,目前已使用到(171)
                {
                    id: 171,
                    name: {
                        zh: "帮助图标",
                        en: "Help Icon",
                        fr: "",
                        de: "",
                        jp: "",
                        es: "",
                        pt: "",
                        it: "",
                        tw: "",
                        kr: "",
                        id: "",
                    },
                    parentID: 6,
                    type: "display",
                    children: [
                        {
                            id: 321,
                            name: {
                                zh: "帮助中心",
                                en: "Help Center",
                                fr: "Centre d'aide",
                                de: "Support-Center",
                                jp: "ヘルプセンター",
                                es: "Centro de ayuda",
                                pt: "Centro de Ajuda",
                                it: "Centro Assistenza",
                                tw: "帮助中心",
                                kr: "도움말",
                                id: "Pusat Bantuan",
                            },
                            parentID: 171,
                            type: "href",
                            children: [],
                            function: "helpCenter",
                        },
                        {
                            id: 322,
                            name: {
                                zh: "快捷键",
                                en: "Hotkey Reference",
                                fr: "Raccourci",
                                de: "Hotkey",
                                jp: "ショートカット",
                                es: "Referencia de Hotkey",
                                pt: "Referência de Tecla de Atalho",
                                it: "Riferimento Scorciatoie",
                                tw: "快速鍵",
                                kr: "단축키",
                                id: "Referensi Tombol Cepat",
                            },
                            parentID: 171,
                            type: "alert",
                            children: [],
                            function: "helpShortKey",
                        },
                        {
                            id: 323,
                            name: {
                                zh: "我要反馈/反馈中心",
                                en: "Feedback/Report Error",
                                fr: "Retour",
                                de: "Feedback",
                                jp: "フィードバック",
                                es: "Retroalimentación",
                                pt: "Feedback",
                                it: "Feedback",
                                tw: "反馈社区",
                                kr: "피드백",
                                id: "Umpan Balik",
                            },
                            parentID: 171,
                            type: "href",
                            children: [],
                            function: "helpReportError",
                        },
                        {
                            id: 343,
                            name: {
                                zh: internal ? "新手教程/新手向导/入门视频/新手任务" : "新手向导",
                                en: internal ? "Operation Guide/Get Started/Getting Started Video" : "Started Guide",
                                fr: "Guide d'opération/Guide novice/Vidéo de démarrage",
                                de: "Gebrauchsanleitung/Anfängerführung/Einführungsvideo",
                                jp: "操作ガイド/スタートガイド",
                                es: "Manual de operaciones/Guía del novato/Video de introducción",
                                pt: "Guia de Operação/Guia para Principiantes/Vídeo de Introdução",
                                it: "Guida operativa/Guida per principianti/Video per iniziare",
                                tw: "操作指引/新手嚮導/入門視訊",
                                kr: "운영 가이드",
                                id: "Panduan operasi",
                            },
                            parentID: 171,
                            type: "click",
                            children: [],
                            function: "helpGuides",
                        },
                        {
                            id: 344,
                            name: {
                                zh: "视频教程",
                                en: "Video Tutorial",
                                fr: "Vidéo tutoriel",
                                de: "Video Anleitung",
                                jp: "チュートリアル",
                                es: "Video Tutorial",
                                pt: "Vídeo Tutorial",
                                it: "Tutorial Video",
                                tw: "绘图视频教程",
                                kr: "동영상 튜토리얼",
                                id: "Tutorial Video",
                            },
                            parentID: 171,
                            type: "click",
                            children: [],
                            function: "helpVideo",
                        },
                        {
                            id: 345,
                            name: {
                                zh: "新功能",
                                en: "What's New/New Features",
                                fr: "Quoi de neuf",
                                de: "Was neu ist",
                                jp: "新機能",
                                es: "Qué hay de nuevo",
                                pt: "O que há de novo",
                                it: "Cosa nuova c'è",
                                tw: "新功能",
                                kr: "업데이트 정보",
                                id: "Yang Baru",
                            },
                            parentID: 171,
                            type: "click",
                            children: [],
                            function: "newFunc",
                        },
                        {
                            id: 346,
                            name: {
                                zh: "在线客服",
                                en: "Online Support",
                                fr: "Support en ligne",
                                de: "Online-Hilfe",
                                jp: "オンラインサポート",
                                es: "Soporte en línea",
                                pt: "Suporte Online",
                                it: "Supporto Online",
                                tw: "線上支援",
                                kr: "온라인 지원",
                                id: "Dukungan Online",
                            },
                            parentID: 171,
                            type: "click",
                            children: [],
                            function: "helpOnlineSupport",
                        },
                        {
                            id: 347,
                            name: {
                                zh: "功能教程",
                                en: "Function Tutorial",
                                fr: "Tutoriel sur les fonctions",
                                de: "Funktionstutorial",
                                jp: "使い方とコツ",
                                es: "Tutorial de funciones",
                                pt: "Tutorial de Função",
                                it: "Tutorial di Funzione",
                                tw: "功能介紹",
                                kr: "기능 튜토리얼",
                                id: "Tutorial Fungsi",
                            },
                            parentID: 171,
                            type: "click",
                            children: [],
                            function: "funcTutorial",
                        },
                    ],
                    function: "",
                },
            ],
            function: "",
        },
    ],
    function: "",
};
function searchD(map) {
    // 深度遍历
    let stack = [];
    let data = [];
    if (map) {
        stack.push(map);
        while (stack.length > 0) {
            let node = stack.pop();
            data.push({
                name: node.tempName,
                type: node.type,
                func: node.function,
            });
            if (node.children) {
                let children = node.children;
                for (let i = children.length - 1; i >= 0; i--) {
                    if (node.name) node.children[i].tempName = `${node.tempName} -> ${node.children[i].name}`;
                    else node.children[i].tempName = `${node.children[i].name}`;
                    stack.push(node.children[i]);
                }
            }
        }
    }
    return data;
}
function searchW(map, lang) {
    // 广度遍历
    let stack = [];
    let data = [];
    if (map) {
        stack.unshift(map);
        while (stack.length > 0) {
            let node = stack.shift();
            data.push({
                name: node.tempName,
                type: node.type,
                func: node.function,
            });
            if (node.children) {
                let children = node.children;
                for (let i = 0; i < children.length; i++) {
                    if (node.name[lang]) node.children[i].tempName = `${node.tempName} -> ${node.children[i].name[lang]}`;
                    else node.children[i].tempName = `${node.children[i].name[lang]}`;
                    stack.push(node.children[i]);
                }
            }
        }
    }
    return data;
}

let searchKey = function (lang, key = "") {
    let data = searchW(funcMap, lang);
    let result = data.filter((v, k) => {
        return v.name && v.name.toUpperCase().includes(key.toUpperCase());
    });
    // 过滤模糊匹配关键词：map 中的 name 字段，/ 号之前的字符串为标准名称，后面部分为模糊匹配关键词
    // 对于部分功能在不同于语言下不开放的情况，不填写相关语言字段即可
    result.map((item) => {
        let oName = item.name.split(" -> "),
            nName = [];
        for (let i = 0; i < oName.length; i++) {
            const name = oName[i];
            let showName = name.includes("/") ? name.split("/")[0] : name;
            nName.push(showName);
        }
        item.name = nName.join(" -> ");
    });
    return result;
};

export { searchKey };
